import React from 'react';
import { ErrorBoundary, FallbackRender } from '@sentry/react';

const ErrorFallback: FallbackRender = ({ error, resetError }) => {
  const errorMessage = error instanceof Error ? error.message : 'An unexpected error occurred';
  
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] p-6 bg-gray-50 border border-gray-200 rounded-lg shadow-sm">
      <div className="max-w-lg w-full text-center">
        <h2 className="text-2xl font-bold text-red-600 mb-4">Something went wrong</h2>
        <p className="text-gray-700 mb-6">{errorMessage}</p>
        <button
          onClick={resetError}
          className="px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90 transition-colors"
        >
          Try again
        </button>
      </div>
    </div>
  );
};

interface SentryErrorBoundaryProps {
  children: React.ReactNode;
}

export const SentryErrorBoundary: React.FC<SentryErrorBoundaryProps> = ({ children }) => {
  return (
    <ErrorBoundary
      fallback={ErrorFallback}
      onError={(error) => {
        console.error('Caught error in Sentry Error Boundary:', error);
      }}
    >
      {children}
    </ErrorBoundary>
  );
};

export default SentryErrorBoundary; 